<template>
  <div class="body-container border-container">
    <p class="notification-title">
      <span>
        <svg style="vertical-align: middle;" class="mr-15" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
          <path
            fill="var(--secondary)"
            d="M31.11 6.8C29.086 2.392 25.62.148 20.801.033c-2.166-.06-4.326-.022-6.49-.003-1.468.013-2.96-.08-4.39.14C5.189.896 2.066 3.618.603 8.157c-.774 2.404-.713 4.93-.32 7.373.73 4.42 3.364 7.373 7.565 8.89.737.227 1.484.418 2.24.57v.32c0 1.52-.016 3.043 0 4.562 0 .383.088.762.256 1.106.66 1.221 2.256 1.375 3.232.32 1.786-1.9 3.575-3.808 5.325-5.738.154-.198.355-.355.585-.457.23-.101.48-.145.73-.126 1.454.077 2.91-.134 4.282-.62 1.373-.488 2.636-1.24 3.718-2.217 2.07-1.834 3.376-4.129 3.664-6.892.122-1.573.151-3.152.087-4.728-.025-1.286-.318-2.552-.858-3.719zM16.321 20.828c-.346.007-.686-.09-.977-.277-.291-.188-.52-.458-.657-.776-.137-.319-.176-.67-.112-1.011.063-.341.227-.655.47-.902.242-.247.553-.417.892-.486.339-.07.691-.036 1.011.096.32.131.594.356.786.644.192.289.294.628.293.974.002.457-.176.896-.495 1.222-.32.325-.755.51-1.211.516zm1.357-6.95c-.076.034-.14.09-.18.163-.042.072-.06.155-.05.238.015.542 0 1.083 0 1.654h-2.673c0-.083-.019-.164-.019-.244v-2.654c-.003-.07.017-.14.056-.198.04-.058.098-.1.165-.123.923-.403 1.726-1.038 2.333-1.843.326-.422.552-.913.662-1.436.103-.46.025-.942-.218-1.346-.244-.404-.633-.698-1.087-.82-1.165-.337-2.32.236-2.605 1.297-.042.164-.064.32-.096.513h-2.733c.046-.401.112-.8.198-1.195.264-.93.809-1.756 1.56-2.364.75-.608 1.67-.97 2.632-1.034 1.098-.099 2.197.188 3.107.811.91.624 1.575 1.545 1.882 2.606.278.989.181 2.046-.272 2.968-.556 1.252-1.483 2.302-2.656 3.007h-.006z"
          />
        </svg>
      </span>
      <span v-translate:need_help="lang">Need Help?</span>
    </p>
    <div class="notification-container help-box">
      <div class="notification-box">
        <div class="card activity-list-help-card">
          <div class="card-header" id="help">
            <a href="#" class="btn btn-header-link" data-toggle="collapse" :data-target="'#need-help'" aria-expanded="true" aria-controls="need-help">
              {{ study.name }}
              <span class="float-right">
                <img src="static/img/participant-portal/forward_arrow.svg" alt="chevron-right" />
              </span>
            </a>
          </div>
          <div id="need-help" class="collapse" aria-labelledby="need-help" :data-parent="'#need-help'">
            <div class="card-body"></div>
          </div>
        </div>
        <div class="text-center">
          <a class="onboard-btn btn" :href="callToStudyCenter" v-translate:call_study_site="lang">Call Study Site</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "need-help",
  data() {
    return {
      callToStudyCenter: "tel:",
      studyEmail: "mailto:",
      studyFax: "tel:"
    };
  },
  computed: {
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    study() {
      return this.$store.getters.getParticipantsPortalStudyData;
    }
  },
  mounted() {
    this.callToStudyCenter += this.globalElements.contactPhoneNumber;
  }
};
</script>

<style scoped type="scss">
.notification-title {
  margin: 0;
  font-family: RobotoRegular;
  font-size: 24px;
  font-weight: bold;
  line-height: 0.92;
  letter-spacing: -0.41px;
  text-align: center;
  color: #4a4a4a;
  padding: 44px;
}
.notification-container {
  width: 100%;
  min-height: calc(100vh - 250px);
  padding: 0 0;
  padding-top: 15vh;
  background-image: radial-gradient(#ffffff, rgba(255, 255, 255, 0)), linear-gradient(to bottom, #f3f3f4, #f3f3f4);
}
.box-padding {
  padding-top: 3rem;
}
.notification-box {
  width: 40%;
  height: auto;
  margin: auto;
  padding: 70px 50px;
  border-radius: 8px;
  -webkit-box-shadow: 0 4px 10px 0 rgb(0 0 0 / 25%);
  box-shadow: 0 4px 10px 0 rgb(0 0 0 / 25%);
  background-color: #ffffff;
}
.card-header {
  background-color: transparent;
}
.card-header .btn-header-link {
  display: block;
}
.onboard-btn {
  color: #ffffff;
  width: 100%;
  padding: 12px 54px;
  border-radius: 12px;
  background-color: var(--secondary);
}
</style>
